<template>
    <StoreModal
            class="invite-user-modal"
            name="TransferOrganizationModal"
            :value="isOpen"
            :title="title"
            @closeModal="handleCancelCreate"
    >
        <template #header>
            <div class="invite-user-modal__header" v-if="!isRequestFinish">
                <div class="title">
                    {{ title }}
                </div>
            </div>
        </template>
        <template #body>
            <div class="modal-wrapper" v-if="hasUsers && !isSuccess && !isRequestFinish">
                <div class="description">
                    {{$t('organization.modal_transfer_desc')}}
                </div>
                <div class="invite-user-modal__input-wrapper">
                    <organisation-user-select
                        v-model="user"
                        :placeholder="$t('organization.modal_take_user')"
                        :label="$t('organization.organization_user')"
                        :list="listUsers"
                        uniq-key="id"
                        clearable
                        @input="handleRole"
                    />
                </div>
            </div>
            <div v-if="!hasUsers && !isSuccess && !isRequestFinish" class="modal-wrapper">
                <div class="description">
                    {{$t('organization.modal_transfer_empty')}}
                </div>
            </div>
            <div v-if="isSuccess && isRequestFinish" class="modal-wrapper">
                <div class="finish-modal-wrapper">
                    <svg class="icon" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_14835_39901)">
                            <rect width="60" height="60" rx="10" fill="#5BB24D"/>
                            <path d="M36.3102 23.5605C36.9326 22.9382 37.9417 22.9382 38.5641 23.5605C39.1789 24.1753 39.1864 25.1674 38.5867 25.7914L30.1033 36.3957C30.0911 36.411 30.078 36.4256 30.0641 36.4395C29.4417 37.0619 28.4326 37.0619 27.8102 36.4395L22.1865 30.8158C21.5641 30.1934 21.5641 29.1842 22.1865 28.5618C22.8089 27.9395 23.818 27.9395 24.4404 28.5618L28.8892 33.0106L36.268 23.6082C36.2811 23.5915 36.2952 23.5756 36.3102 23.5605Z" fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_14835_39901">
                                <rect width="60" height="60" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                    <div class="invite-user-modal__header">
                        <div class="title">
                            {{ $t('organization.modal_transfer_success') }}
                        </div>
                    </div>
                    <div class="success-wrapper">
                        <div class="description">
                            {{ $t('organization.modal_transfer_new_title') }} <span class="purple">{{ user.email }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!isSuccess && isRequestFinish" class="modal-wrapper">
                <div class="finish-modal-wrapper">
                    <svg class="icon" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_14835_39931)">
                            <rect width="60" height="60" rx="10" fill="#B24D4D"/>
                            <path d="M24.8098 18.2197C24.9504 18.079 25.1412 18 25.3401 18H34.6599C34.8588 18 35.0496 18.079 35.1902 18.2197L41.7803 24.8098C41.921 24.9504 42 25.1412 42 25.3401V34.6599C42 34.8588 41.921 35.0496 41.7803 35.1902L35.1902 41.7803C35.0496 41.921 34.8588 42 34.6599 42H25.3401C25.1412 42 24.9504 41.921 24.8098 41.7803L18.2197 35.1902C18.079 35.0496 18 34.8588 18 34.6599V25.3401C18 25.1412 18.079 24.9504 18.2197 24.8098L24.8098 18.2197ZM25.6508 19.5L19.5 25.6508V34.3492L25.6508 40.5H34.3492L40.5 34.3492V25.6508L34.3492 19.5H25.6508Z" fill="white"/>
                            <path d="M24.9697 24.9697C25.2626 24.6768 25.7374 24.6768 26.0303 24.9697L30 28.9393L33.9697 24.9697C34.2626 24.6768 34.7374 24.6768 35.0303 24.9697C35.3232 25.2626 35.3232 25.7374 35.0303 26.0303L31.0607 30L35.0303 33.9697C35.3232 34.2626 35.3232 34.7374 35.0303 35.0303C34.7374 35.3232 34.2626 35.3232 33.9697 35.0303L30 31.0607L26.0303 35.0303C25.7374 35.3232 25.2626 35.3232 24.9697 35.0303C24.6768 34.7374 24.6768 34.2626 24.9697 33.9697L28.9393 30L24.9697 26.0303C24.6768 25.7374 24.6768 25.2626 24.9697 24.9697Z" fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_14835_39931">
                                <rect width="60" height="60" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                    <div class="invite-user-modal__header">
                        <div class="title">
                            {{ $t('organization.modal_transfer_error') }}
                        </div>
                    </div>
                    <div class="error-description">
                        <div class="description">
                            {{ $t('organization.modal_transfer_error_id') }}
                        </div>
                        <span class="traceId">
                            {{ traceId | preparedString }}
                            <copy :value="traceId" />
                        </span>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <div class="invite-user-modal__footer" v-if="hasUsers && !isRequestFinish">
                <base-button :label="$t('api_keys.close')" type="secondary" @click="handleCancelCreate" />
                <base-button
                        type="primary"
                        @click="handleInviteRequest"
                        :disabled="disabledBtn"
                        :label="$t('organization.modal_btn_invite')"
                />
            </div>
            <template v-else>
                <div class="invite-user-modal__close-btn">
                    <base-button :label="$t('organization.modal_btn_close')"  class="invite-user-modal__btn" @click="handleCancelCreate" />
                </div>
            </template>
        </template>

    </StoreModal>
</template>

<script>

import {mapGetters, mapActions, mapState} from 'vuex';

import AtModal from 'at-ui/src/components/modal';
import LoadingSpinner from "/public/components/elements/LoadingSpinner";
import AtButton from 'at-ui/src/components/button';
import BaseModal from "../BaseModal";
import CopyString from "/public/components/elements/CopyString";
import OrganisationRoleSelect from "@/public/components/elements/organizations/Select/organisationRoleSelect.vue";
import OrganisationUserSelect from "@/public/components/elements/organizations/Select/organisationUserSelect.vue";
import BaseInput from "@/public/components/common/uiKit/input/base/index.vue";
import BaseButton from "@/public/components/common/uiKit/button/base/index.vue";
import Copy from "@/public/components/common/copy.vue";

export default {
    name: 'TransferOrganizationModal',
    components: {
        Copy,
        BaseButton,
        BaseInput,
        OrganisationRoleSelect,
        OrganisationUserSelect,
        BaseModal,
        AtModal,
        LoadingSpinner,
        AtButton,
        CopyString,
        StoreModal: () => import(/* webpackChunkName: "/public/components/modals/StoreModal" */ '/public/components/modals/StoreModal'),
    },

    data() {
        return {
            isLoading: false,
            userName: '',
            email: '',
            user: null,
            urlStep: false,
            emailNotValid: false,
        };
    },

    created() {
        this.getOrganizationRoles();
    },

    computed: {
        ...mapGetters('app', [
            'isOpenModal',
        ]),

        ...mapState('app', {
            modalPayload: state => state.modal.payload,
        }),
        ...mapState('user', {
            userOtpEnabled: state => state.user.otpToken,
        }),
        ...mapState('organizations', [
            'listRoles',
            'inviteUrl',
            'listUsers',
        ]),
        hasUsers () {
            return this.listUsers.length
        },
        isSuccess () {
            if (!this.modalPayload?.success) return false
          return this.modalPayload?.success
        },
        isRequestFinish() {
            if (!this.modalPayload?.finish) return false
            return this.modalPayload?.finish
        },
        traceId() {
            if (!this.modalPayload?.traceId) return ''
            return this.modalPayload?.traceId
        },
        isOpen() {
            const {
                $options: {
                    name,
                },
                isOpenModal,
            } = this;

            return isOpenModal(name);
        },

        title() {
            return this.$t('organization.modal_transfer')
        },

        disabledBtn() {
            return !this.user;
        },
    },

    methods: {
        ...mapActions('app', [
            'openModal',
            'closeModal',
        ]),

        ...mapActions('organizations', [
            'createOrganizationUser',
            'getOrganizationRoles',
            'getOrganizationUsers',
        ]),

        clearAllData() {
            this.isLoading = false;
            this.isSuccess = false;
            this.user = null;
        },

        handleInviteRequest() {
            if (this.disabledBtn) {
                return
            }
            if (!this.userOtpEnabled) {
                this.openModal({
                    name: 'TwoFaRestriction',
                });
            }
            this.openModal({
                name: 'TwoFaConfirmation',
                payload: {
                    id: this.user?.id
                }
            });
            // this.createOrganizationUser({
            //     name: this.userName,
            //     email: this.email,
            //     id: this.role.id,
            // }).then((data) => {
            //     if (data === 1014 || data === 2003) {
            //         this.emailNotValid = data;
            //         return;
            //     }
            // });
        },

        handleRole(value) {
            this.role = value;
        },

        handleCancelCreate() {
            const {
                closeModal,
                clearAllData,
            } = this;

            closeModal();

            setTimeout(() => {
                clearAllData();
            }, 500);
        },
    },
};

</script>

<style lang="scss" scoped>
.icon {
    margin-bottom: 30px;
}
.modal-wrapper {
    padding: 0 30px;
}
.error-description {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    margin-top: 20px;
    .description {
        margin-bottom: 0;
        font-weight: 500;
    }
}
.success-wrapper {
    margin-bottom: 30px;
    margin-top: 20px;
    font-weight: 500;
    .description {
        margin-bottom: 0;
        font-weight: 500;
    }
}
.traceId {
    color: var(--new-front-primary-font-color);
    font-size: $h4;
    font-weight: 500;
    display: flex;
    align-items: center;
    margin-left: 5px;
}
.finish-modal-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.purple {
    color: var(--new-front-purple)
}
.success-block {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.invite-user-modal {
    &::v-deep {
        .list {
            max-height: 290px !important;
        }
    }
    font-family: $Gilroy;
    &__success {
        &-title {
            margin-top: 30px;
            font-weight: 500;
            color: var(--new-front-primary-font-color);
            font-size: $h1;
        }
        &-subtitle {
            margin-top: 20px;
            font-size: $h4;
            color: var(--new-front-secondary-font-color);
            margin-bottom: 10px;
        }
    }
    &__header {
        text-align: center;
        .title {
            font-size: $h1;
            font-weight: 500;
            color: var(--new-front-primary-font-color);
            @media (max-width: 450px) {
                font-size: $h2;
            }
        }
    }
    color: var(--new-front-primary-font-color);
    &__footer {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
    }
  &__full-width-btn {
    width: 100%;
  }

  &__message {
    color: var(--primary-font-color);
      font-family: $Gilroy;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 23px;
    text-align: center;

    span {
      color: #0059F7;
    }
  }

  &__alias {
      font-family: $Gilroy;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary-font-color);
    margin-top: 25px;
  }

  &__input-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__input-title {
      font-family: $Gilroy;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary-font-color);
    margin-bottom: 10px;
  }

  &__input {
    &::v-deep .at-input__original {
      background: var(--secondary-color);
      border: 1px solid var(--border-color);
      box-sizing: border-box;
      border-radius: 12px;
      min-height: 47px;
      color: var(--primary-font-color);
        font-family: $Gilroy;
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 148.8%;
      padding-left: 30px;

      &::placeholder {
          font-family: $Gilroy;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 148.8%;
        color: #8F949A;
      }
    }
  }

  &__link-text {
      font-family: $Gilroy;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary-font-color);
    margin-bottom: 25px;
  }

  &__link-wrapper {
    display: flex;
    align-items: center;
  }

  &__link-block {
    display: flex;
  }

  &__link {
    font-family: $Gilroy;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    text-decoration-line: underline;
    color: var(--new-front-purple);
    margin-right: 10px;
  }

  &__close-btn {
    width: 100%;
  }

  &__btn {
    min-width: 100%;
  }
}
.at-input--error ::v-deep .at-input__original {
  border-color: red;
}
.inputError-title {
  color: #EB5757;
  font-family: var(--font-family);
  font-size: 14px;
  line-height: var(--line-height);
}
.description {
    text-align: center;
    font-size: $h4;
    font-weight: 400;
    color: var(--new-front-secondary-font-color);
    margin-bottom: $p30;
    @media (max-width: 450px) {
        font-size: $h6;
        margin-bottom: $p20;
    }
}
</style>
